import { FC } from 'react';
import { DeviceTypes } from '../../constants/deviceTypes';
import { FloatingGreeting,FooterContainer,FooterContainerMessage,MessageContent,FooterContainerIconFrame } from '../Footer/Footer.styled';

import openWhatsapp from '../../utils/openWhatsapp';

interface WhatsappFooterButtonProps {
  device: DeviceTypes;
}

const WhatsappFooterButton: FC<WhatsappFooterButtonProps> = ({ device }) => {
  return (
    <>
    <FloatingGreeting
      onClick={() => {
        openWhatsapp(device);
      }}
      style={{
        cursor: 'pointer',
      }}
    >
      <FooterContainer>
        <FooterContainerMessage>
          <div className='row' style={{alignItems:'center'}}>
            <div className='col-10' style={{paddingRight:0}}>
          <MessageContent>Hi there 👋! <br/><p style={{fontSize:15,paddingBottom:0,marginBottom:0}}>How can I help you?</p></MessageContent>
          </div>
          <div className='col-2' style={{paddingRight:0,paddingLeft:0}}>
         <FooterContainerIconFrame><img src="/city-lawyers/icons/whatsapp.svg" width="34" alt="whatsapp" />
         </FooterContainerIconFrame>
         </div>
         </div>
         
        </FooterContainerMessage>
      </FooterContainer>
    </FloatingGreeting>

    </>
  );
};

export default WhatsappFooterButton;
